<template>
  <div
    class="border-b-black-10"
    :class="subCategory ? 'border-0 pl-3' : 'border-b'"
  >
    <Button
        type="ghost"
        ignore-capitalisation
      class="whitespace-no-wrap text-md inline-flex w-full cursor-pointer items-center justify-between gap-2 leading-5 tracking-wide"
      :class="[subCategory ? 'h-[54px]' : 'h-14', { 'font-bold': open }]"
      data-test-id="mobile-navigation-accordion-item-link"
      @click="onClickTitle"
    >
      {{ category.name }}
      <Button
        v-if="!hideCollapse"
        type="ghost"
        no-padding
        :aria-label="category.name"
        :class="{ 'border-l border-l-black-10 pl-2': !subCategory }"
        data-test-id="mobile-navigation-collapse-toggle-button"
        @click="toggle"
      >
        <div
          class="m-2"
          :class="{ 'rounded-full border border-black-20': subCategory }"
        >
          <IconArrowDown
            class="m-2 size-4 transition"
            :class="{ '-rotate-180': open }"
          />
        </div>
      </Button>
    </Button>
    <div v-if="open && !hideCollapse">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Category } from '@scayle/storefront-nuxt'

const props = defineProps({
  category: {
    type: Object as PropType<Partial<Category>>,
    required: true,
  },
  hideCollapse: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  subCategory: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
})

const emit = defineEmits(['click:item'])

const { toLocalePath } = useRouteHelpers()
const open = ref(false)

const route = useRoute()
const { path, countryLevelCustomData } = props.category

const toggle = () => {
  open.value = !open.value
}

onMounted(() => {
  open.value =
    props.category.children
      ?.map((i) => toLocalePath(i.path))
      .includes(route.path) || false
})

const categoryPath = computed(() => {
  if (!path) return ''

  if (countryLevelCustomData?.cmsPagePath) {
    return toLocalePath(countryLevelCustomData.cmsPagePath)
  }

  return toLocalePath(path)
})

const onClickTitle = () => {
  if (categoryPath.value) {
    emit('click:item', categoryPath.value)
  } else if (!props.hideCollapse) {
    toggle()
  }
}
</script>
